/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_No_DataInputs */

const en_admin_categories_no_data = /** @type {(inputs: Admin_Categories_No_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No categories yet`)
};

const zh_admin_categories_no_data = /** @type {(inputs: Admin_Categories_No_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无分类`)
};

/**
* | output |
* | --- |
* | "No categories yet" |
*
* @param {Admin_Categories_No_DataInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_categories_no_data = /** @type {((inputs?: Admin_Categories_No_DataInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_No_DataInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_categories_no_data(inputs)
	return zh_admin_categories_no_data(inputs)
});
export { admin_categories_no_data as "admin.categories.no_data" }